import type { DocumentId, DocumentRevision } from 'core/types';
import type { AxiosRequestConfig } from 'axios';
import { IssuesRepository } from './Issues.repository';
import type { IssueModel } from './Issue.model';

export class IssuesService {
  issuesRepo: IssuesRepository = new IssuesRepository();

  getIssue(id: DocumentId) {
    return this.issuesRepo.get(id);
  }

  create(issue: IssueModel) {
    return this.issuesRepo.create(issue);
  }

  update(issue: IssueModel) {
    return this.issuesRepo.update(issue);
  }

  getByType(typeName: string, id: DocumentId) {
    return this.issuesRepo.getByType(typeName, id);
  }

  getAll(config?: AxiosRequestConfig) {
    return this.issuesRepo.getAll(config);
  }

  getChanges(id: DocumentId, since?: DocumentRevision) {
    return this.issuesRepo.getChanges(id, since);
  }
}
